import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const causeSelectionKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'causeSelections'] as const,
    id: <U extends QueryKeyParam>(causeSelectionId: U) =>
      createQueryKey({
        all: [...keys, 'causeSelections', causeSelectionId] as const,
        detail: [...keys, 'causeSelections', causeSelectionId, 'detail'] as const,
      }),
  });

export { causeSelectionKeys };
